import ScoreByHourOfDayWidget from './ScoreByHourOfDayWidget';
export default ScoreByHourOfDayWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/ScoreByHourOfDayWidget/index.js